// What a delete or a retry says it does to the bill's allocations (LB-5952). Kept apart from companyBillRows so the
// Retry dialog can say it without that module's imports.

/**
 * What becomes of deleted bills, for every delete confirmation (LB-6035): archived, and a fresh read if the same file is
 * uploaded again, so nothing from the deleted bill carries over to the new one. A file another live bill still uses
 * keeps sharing that bill's read, which the note says too.
 */
export const getArchivedNotErasedNote = function () {
  let count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return count > 1 ? "They're archived, not erased. Upload them again and they're read from scratch, unless another bill still uses the same file." : "It's archived, not erased. Upload it again and it's read from scratch, unless another bill still uses the same file.";
};

/** What deleting one bill does, for its confirmation: an allocated one takes its allocations with it (LB-5952). */
export const getDeleteConfirmation = _ref => {
  let fileName = _ref.fileName,
    _ref$allocationCount = _ref.allocationCount,
    allocationCount = _ref$allocationCount === void 0 ? 0 : _ref$allocationCount;
  const removed = "".concat(fileName || 'This bill', " will be removed from your bills");
  if (allocationCount > 1) {
    return "".concat(removed, ", and its ").concat(allocationCount, " allocations archived with it: their tables go back to pending. ").concat(getArchivedNotErasedNote());
  }
  if (allocationCount === 1) {
    return "".concat(removed, ", and its allocation archived with it: its table goes back to pending. ").concat(getArchivedNotErasedNote());
  }
  return "".concat(removed, ". ").concat(getArchivedNotErasedNote());
};

/** What a retry does to the bill's allocations, for its dialog: the same as a delete, in as many as there are. */
export const getRetryAllocationNote = function () {
  let allocationCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  if (allocationCount > 1) {
    return "Its ".concat(allocationCount, " allocations are archived with it, and their tables go back to pending.");
  }
  return allocationCount === 1 ? 'Its allocation is archived with it, and its table goes back to pending.' : '';
};